import * as Sentry from '@sentry/browser';
import { SentryConfiguration } from 'src/AppConfiguration';

/**
 * This service provides an integration to our Sentry instance for frontend error logging
 * running at https://sentry.controlexpert.com.
 */
export class SentryService {
	constructor(sentryConfig: SentryConfiguration) {
		Sentry.init({
			dsn: sentryConfig.dsn,
			environment: sentryConfig.environment,
			tracesSampleRate: sentryConfig.tracesSampleRate,
		});
	}

	public registerOnErrorHandler() {
		window.onerror = (
			event: Event | string,
			source?: string,
			fileno?: number,
			columnNumber?: number,
			error?: Error
		): void => {
			Sentry.getCurrentScope().setExtras({ event, fileno, columnNumber });
			Sentry.captureException(error);
		};
	}
}
